<template>
  <div>
    <div class="users-row-email">
      <span v-if="device.ring_solutions_url">
        <a
            :href="device.ring_solutions_url"
            target="_blank">
          {{ device.name }}
        </a>
      </span>
      <span v-else>
        <span v-if="device.type=='racp'">
          <a>
            {{ device.name }}
          </a>
        </span>
        <span v-else>
          <router-link :to="{ name: 'Device', params: { doorbot_id: device.doorbot_id} }">
            {{ device.name || "-" }}
          </router-link>
        </span>
      </span>
      <div style="float: right">
        {{ product.description }}
      </div>
    </div>
    <div class="ring-card__input-label">
      <span>{{ device.mac_address || device.hardware_id }} </span>
      <div style="float:right">
        {{ getRBACRoleDescription(userRole || device.role) | capitalize }}
      </div>
    </div>
  </div>
</template>

<script>
import { getRBACRoleDescription } from "@/utils/utils";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: sharedGetters } = createNamespacedHelpers("shared");

export default {
  name: "DeviceLocationRow",
  props: {
    device: {
      type: Object,
      required: true,
    },
    userRole: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    ...sharedGetters(["products"]),
    product() {
      return this.products.find((p) => p.kind == this.device.type) || {};
    },
  },
  methods: {
    getRBACRoleDescription,
  },
};
</script>
